var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24px","viewBox":"0 -960 960 960","width":"24px","fill":"currentColor"}},[_c('path',{attrs:{"d":"m336-280-56-56 144-144-144-143 56-56 144 144 143-144 56 56-144 143 144 144-56 56-143-144-144 144Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }